// ── CLIENT-FACING DISCLOSURES (2026-11-02) ─────────────────────────────
//
// Mirrored in backend/routers/vexos_proposal_pdf.py — change both together, or
// the web proposal and the PDF a client signs will word the same thing two
// ways. Strings carry HTML entities because ScopeLine subs render as HTML.

// AI, said plainly wherever an AI workflow is sold. Conceptual Rendering
// Hybrid Workflow (2026-11-03): the unit is fully modeled and AI assists the
// design, materials and finishes; the trade-off is fewer extensive revisions.
export const AI_CONCEPTUAL_DISCLOSURE =
  "hybrid workflow &mdash; fully modeled, with AI assisting the design, materials and finishes; less flexibility for extensive revisions and design adjustments";
export const AI_FLOORPLAN_DISCLOSURE =
  "AI hybrid workflow &mdash; generated with AI from your plans; furnishings are representative";

// The proposal is priced on what the client has told us; the planning call
// confirms it. Nothing changes without the client's written approval.
export const SCOPE_CONFIRMATION_NOTE =
  "This proposal is based on the project details you have shared with us so far. Scope is confirmed on your production planning call; if those details change, scope and fees are updated with your written approval.";
